export default __webpack_public_path__ + "static/media/SE50.8a213097.png";